import PropTypes from 'prop-types';
import React from 'react';

export default function AtrPlaceholderPrompt({size = "standard"}) {
  require("./AtrPlaceholderPrompt.scss");

  const img = logo => <img key={logo} width="60" height="35" src={`/img/masthead/${logo}.png`}/>

  return <div className={`atr-placeholder-prompt-${size}`}>
        <div className="atr-placeholder-prompt-accounts">
          <div className="atr-placeholder-prompt-accounts-text">
            We understand the importance of these replays and will reinstate them as soon as possible. Replays from Racing TV racecourses are available as normal.
          </div>
        </div>
    </div>;
}

AtrPlaceholderPrompt.propTypes = {
  size: PropTypes.string
};

export const AtrPlaceholderPromptHeading = "We regret that replays from Sky Sports Racing racecourses are unavailable until further notice.";



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/AtrPlaceholderPrompt.js